//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { OpKind } from '@taquito/taquito'
export default {
  components: {},
  props: {
    project: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      agree: false,
      validated: false,
      balance: 0,
      reserved: false,
      referredBy: '',
      loading: false,
    }
  },
  computed: {
    collapsed() {
      return this.$store.state.prefs.collapseSmiths
    },
    shared() {
      return (this.project.referral_percentage / 1000) * 100
    },
    userAddress() {
      return this.$store.getters.userAddress
    },
    userAlias() {
      return this.$store.state.userAlias
    },
    shareUrl() {
      return `${window.location.origin}/c/${this.project.slug}/${
        this.userAlias || this.userAddress
      }`
    },
  },
  watch: {
    userAddress() {
      this.checkStatus()
    },
  },
  mounted() {
    this.referredBy = this.$cookies.get(`${this.project.slug}-ref`)

    this.checkStatus()
  },
  methods: {
    setCollapsed(collapsed) {
      this.$store.dispatch('setPref', {
        pref: `collapseSmiths`,
        value: collapsed,
      })
    },
    async copyShareUrl() {
      try {
        await this.$copyText(this.shareUrl)
        this.$store.dispatch('addSnackbar', {
          text: `${this.shareUrl} copied to clipboard!`,
        })
      } catch (e) {
        this.$store.dispatch('addSnackbar', {
          text: `Error copying share url. Please refresh and try again.`,
          type: 'error',
        })
        console.error(e)
      }
    },
    async validateReferredBy() {
      this.loading = true
      const inviteErr = `Your invitation seems to be invalid. Please use a valid invitation to proceed.`
      try {
        // const match = this.referredBy.match(/[A-Za-z0-9_-]+/)
        if (
          !this.referredBy ||
          this.referredBy.length < 4 ||
          this.referredBy.length > 36
        ) {
          this.loading = false
          this.$store.dispatch('addSnackbar', {
            text: inviteErr,
            type: 'error',
          })
          return
        }
        // convert tez domains..
        const match = this.referredBy.match(/tz[A-Za-z0-9_-]{34}/)
        if (!match) {
          const addr = await this.$globals.resolveNameToAddress(this.referredBy)
          if (!addr) {
            this.loading = false
            this.$store.dispatch('addSnackbar', {
              text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
              type: 'error',
            })
            return
          }
          this.referredByAlias = this.referredBy
          this.referredBy = addr
        }
        const { tzktPrefix } = this.$config
        const storageResp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/contracts/${this.project.referral_contract}/storage?path=referrals`
        )
        const bmId = storageResp?.data
        const resp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${bmId}/keys/${this.referredBy}`
        )
        if (!resp?.data) {
          this.loading = false
          this.$store.dispatch('addSnackbar', {
            text: inviteErr,
            type: 'error',
          })
          return
        }

        const transactions = []

        const ref = await this.$globals.tezos.wallet.at(
          this.project.referral_contract
        )
        transactions.push({
          kind: OpKind.TRANSACTION,
          ...ref.methods.set_referred_by(this.referredBy).toTransferParams(),
        })
        const batch = await this.$globals.tezos.wallet.batch(transactions)
        const op = await batch.send()
        await op.confirmation(1)
        this.validated = true
        this.loading = false
      } catch (err) {
        this.loading = false
        console.log(err)
        this.$store.dispatch('addSnackbar', {
          text: 'There was an error while trying to validate. Please try again later. (You can try disconnecting and reconnecting your wallet.)',
          type: 'error',
        })
        if (err?.message && err?.message?.includes('ABORTED_ERROR')) {
          this.disconnectWallet()
        }
      }
    },
    async disconnectWallet() {
      await this.$globals.disconnectWallet()
      this.$store.commit('INIT_USER_WALLET', { wallet: null, alias: null })
    },
    async claimBalance() {
      this.loading = true
      try {
        const transactions = []

        const ref = await this.$globals.tezos.wallet.at(
          this.project.referral_contract
        )
        transactions.push({
          kind: OpKind.TRANSACTION,
          ...ref.methods.claim().toTransferParams(),
        })
        const batch = await this.$globals.tezos.wallet.batch(transactions)
        const op = await batch.send()
        await op.confirmation(1)
        this.balance = 0
        this.loading = false
        this.$store.dispatch('addSnackbar', {
          text: 'You successfully claimed your balance!',
        })
      } catch (err) {
        this.loading = false
        console.log(err)
        this.$store.dispatch('addSnackbar', {
          text: 'There was an error while trying to claim your balance. Please try again later.',
          type: 'error',
        })
        if (err?.message && err?.message?.includes('ABORTED_ERROR')) {
          this.disconnectWallet()
        }
      }
    },
    async checkStatus() {
      this.loading = true
      try {
        const { tzktPrefix } = this.$config
        const storageResp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/contracts/${this.project.referral_contract}/storage?path=referrals`
        )
        const bmId = storageResp?.data
        const resp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${bmId}/keys/${this.userAddress}`
        )
        if (resp?.data) {
          // console.log(resp.data)
          this.balance = parseInt(resp?.data?.value?.bal)
          this.referredBy = resp?.data?.value?.referred_by
          this.validated = true
        } else {
          this.validated = false
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    async connectWallet() {
      this.loading = true

      try {
        const userAddress = await this.$globals.connectWallet()
        const userAlias = await this.$globals.resolveAddressToName(userAddress)
        this.$store.commit('INIT_USER_WALLET', {
          wallet: userAddress,
          alias: userAlias,
        })
        this.$store.dispatch('logTerms', {
          wallet: userAddress,
          version: this.$config.termsVersion,
        })
        this.$store.dispatch('loadBalance', userAddress)
        this.loading = false
        this.checkStatus()
      } catch (e) {
        console.error('Unable to connect wallet', e)
        this.loading = false
      }
    },
  },
}
